<template>
  <div class="container">
    <div class="content">
      <div class="code">
        <div id="codeDom" class="code-container">
          <div class="code-user">
            <img :src="$FILE_PATH + detail.cover" @load="onLoadForCover" />
          </div>
          <div class="code-content">
            <div class="code-title">{{ detail.title }}</div>
            <div class="code-subTitle">{{ detail.subTitle }}</div>
            <img v-if="code" class="code-qrcode" :src="code" />
          </div>
        </div>
      </div>
    </div>

    <div class="handle">
      <div class="handle-item" @click="download">
        <iain-image-domain w="40" h="40" src="static/img/mine/icon15.png" />
        <div class="handle-label">保存</div>
      </div>

      <div class="handle-item" @click="share">
        <iain-image-domain w="40" h="40" src="static/img/mine/icon16.png" />
        <div class="handle-label">分享</div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode'
import html2canvas from 'html2canvas'

export default {
  name: 'UserCode',
  data() {
    return {
      detail: {},

      code: '',
      cover: false,

      codePoster: '',

      Loading: null
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.Loading = this.$toast.loading({ message: '生成二维码中...' })
      const detail = JSON.parse(this.$route.query.query)
      this.detail = detail
      await this.setCode()

      this.Loading.message = '生成海报中...'
      this.$nextTick(this.generatePoster)
    },

    async setCode() {
      const code = await QRCode.toDataURL(this.detail.codeText, { width: 400, height: 400, margin: 0 })

      if (!code) {
        this.Loading.clear()
        this.$toast.fail(' 生成二维码失败')
        return
      }

      this.code = code
    },

    onLoadForCover() {
      this.cover = true
      this.$nextTick(this.generatePoster)
    },

    async generatePoster() {
      if (!this.cover || !this.code) return
      const posterCanvas = await html2canvas(document.getElementById('codeDom'), { backgroundColor: null, scale: 2 })
      this.codePoster = posterCanvas.toDataURL('image/png')
      this.Loading.clear()
    },

    download() {
      uni.postMessage({ data: { type: 'DOWNLOAD', base64: this.codePoster } })
    },

    share() {
      uni.postMessage({ data: { type: 'SHARE', base64: this.codePoster } })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  min-height: 100vh;
  background-color: #f8f8f8;

  .content {
    padding: 112px 95px 95px;

    .code {
      position: relative;

      .code-container {
        padding-top: 76px;
        position: relative;

        .code-user {
          position: absolute;
          top: 0;
          left: 50%;
          z-index: 100;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 152px;
          height: 152px;
          margin-left: -78px;
          border-radius: 50%;
          background: #ffffff;

          img {
            width: 132px;
            height: 132px;
            border-radius: 50%;
          }
        }

        .code-content {
          box-sizing: border-box;
          padding: 100px 60px 60px;
          border-radius: 20px;
          text-align: center;
          background-color: #ffffff;

          .code-title {
            padding-bottom: 25px;
            font-size: 30px;
            color: #222222;
          }

          .code-subTitle {
            padding-bottom: 25px;
            font-size: 28px;
            color: #9a9a9a;
          }

          .code-qrcode {
            width: 440px;
            height: 440px;
          }
        }
      }
    }
  }

  .handle {
    display: flex;
    padding-bottom: 20px;

    .handle-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 50%;
      flex-shrink: 0;

      .handle-label {
        padding-top: 20px;
        color: #000000;
      }
    }
  }
}
</style>>

